import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pro-list-auth',
  templateUrl: './pro-list-auth.component.html',
  styleUrls: ['./pro-list-auth.component.css']
})
export class ProListAuthComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Promotions/promotion-list-authorization/pro-list-auth/pro-list-auth.component.ts